module.exports = __webpack_public_path__ + "img/8.c0b5f195.jpg";